/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoYoutubeIcon16Solid = forwardRef('LogoYoutubeIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.654 3.876C1 4.614 1 5.743 1 8c0 2.257 0 3.386.654 4.124.07.079.143.153.222.222C2.614 13 3.743 13 6 13h4c2.257 0 3.386 0 4.124-.654.079-.07.153-.143.222-.222C15 11.386 15 10.257 15 8c0-2.257 0-3.386-.654-4.124a2.593 2.593 0 0 0-.222-.222C13.386 3 12.257 3 10 3H6c-2.257 0-3.386 0-4.124.654-.079.07-.153.143-.222.222ZM11.204 8 6 10.702V5.298L11.204 8Z" })));
});
